import { render, staticRenderFns } from "./DNNProfileTable.vue?vue&type=template&id=e725883a&scoped=true&"
import script from "./DNNProfileTable.vue?vue&type=script&lang=js&"
export * from "./DNNProfileTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e725883a",
  null
  
)

export default component.exports